import { isRtlLocale, normalizeLocale } from './languages';

export function applyDocumentDirection(language) {
    const lng = normalizeLocale(language);
    const dir = isRtlLocale(lng) ? 'rtl' : 'ltr';
    document.documentElement.lang = lng;
    document.documentElement.dir = dir;
    document.body?.setAttribute('dir', dir);
}
